if (!customElements.get('pre-cart')) {
  customElements.define(
    'pre-cart',
    class PreCart extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener('CART_ITEM_CHANGED', this.onChange.bind(this))
      }

      disconnectedCallback() {
        document.removeEventListener('CART_ITEM_CHANGED', this.onChange.bind(this))
      }

      onChange(event) {
        const {key, quantity, sellingPlan, properties} = event.detail
        if (key && quantity) this.updateCart(key, quantity, sellingPlan, properties)
      }

      updateCart(key, quantity, sellingPlan, properties) {
        this.classList.add('loading')
        const body = {
          id: key,
          quantity: quantity,
          sections: ['header', this.sectionId],
          sections_url: window.location.pathname,
        }
        if (properties) body['properties'] = properties
        if (sellingPlan) body['selling_plan'] = sellingPlan
        if (sellingPlan == 'none') body['selling_plan'] = ''
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`
          },
          body: JSON.stringify(body)
        }

        fetch(theme.routes.cartChange, options)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const sectionHTML = this.getHTMLElement(parsedState.sections[this.sectionId])
          this.replaceElement(sectionHTML, '.pre-cart__form')

          const headerHTML = this.getHTMLElement(parsedState.sections['header'])
          this.replaceElement(headerHTML, '#HeaderCartTrigger')
          document.dispatchEvent(
            new CustomEvent("CART_FORM_RERENDERED")
          );
          this.classList.remove('loading')
        })
        .catch((error) => {
          console.log(error)
          this.classList.remove('loading')
        })
        .finally(() => {
          this.classList.remove('loading')
        });
      }

      getHTMLElement(str) {
        return new DOMParser().parseFromString(str, 'text/html')
      }

      replaceElement(html, selector) {
        const src = document.querySelector(selector)
        const dst = html.querySelector(selector)

        if (src && dst) src.innerHTML = dst.innerHTML

        return
      }

      get sectionId() {
        return this.getAttribute('data-section-id')
      }
    }
  );
}
